<div class="filter-container">
  <button mat-flat-button (click)="onPrev()">Prev</button>
  <!-- Select dropdown for choosing column to filter -->
  <mat-form-field appearance="outline">
    <mat-label>Select Column</mat-label>
    <mat-select [(value)]="selectedColumn" (selectionChange)="onFilterChange()">
      @for (colum of filteredColumns; track colum) {
      <mat-option [value]="colum">{{ colum }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <!-- Text input field for filtering -->
  <mat-form-field appearance="outline">
    <mat-label>Filter</mat-label>
    <input
      matInput
      [(ngModel)]="filterValue"
      (ngModelChange)="onFilterChange()"
      placeholder="Filter by {{ selectedColumn }}"
    />
  </mat-form-field>
  <button mat-flat-button (click)="onNext()">Next</button>
</div>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <ng-container matColumnDef="group">
    <th mat-header-cell *matHeaderCellDef>Group</th>
    <td mat-cell *matCellDef="let element">{{ element.group }}</td>
  </ng-container>
  <ng-container matColumnDef="model">
    <th mat-header-cell *matHeaderCellDef>Model</th>
    <td mat-cell *matCellDef="let element">{{ element.model }}</td>
  </ng-container>
  <ng-container matColumnDef="version">
    <th mat-header-cell *matHeaderCellDef>Version</th>
    <td mat-cell *matCellDef="let element">{{ element.version }}</td>
  </ng-container>
  <ng-container matColumnDef="version-update">
    <th mat-header-cell *matHeaderCellDef>Version update</th>
    <td mat-cell *matCellDef="let element">
      <mat-form-field class="deploy-version" appearance="outline">
        <mat-label>Version</mat-label>
        <mat-select
          (selectionChange)="
            onDeployVersionChange(element.group, element.model, $event.value)
          "
        >
          @for (firmware of getFirmwaresByModel(element.model); track $index) {
          <mat-option [value]="firmware.version">{{
            firmware.version
          }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef>Actions</th>
    <td mat-cell *matCellDef="let element" class="flex-cell">
      <button mat-mini-fab (click)="onDeleteClick(element)">
        <mat-icon color="warn">delete</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
